"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchYtjCompany = void 0;
const rxjs_1 = require("rxjs");
const redux_observable_1 = require("redux-observable");
const operators_1 = require("rxjs/operators");
const Actions = require("../../actions/ytj");
const ActionTypes = require("../../actionTypes/ytj");
const ytj_1 = require("../../types/ytj");
const errorHandling_1 = require("../../utils/errorHandling");
const searchYtjCompany = (action$, _store, { ajax, getToken, baseUrl }) => {
    const getUrl = (searchString) => `${baseUrl}api/ytj/search/${encodeURIComponent(searchString)}`;
    const ajaxOptions = (searchString) => ({
        method: 'GET',
        url: getUrl(searchString),
        headers: {
            Authorization: getToken(),
            'Content-Type': 'application/json'
        }
    });
    const ajaxCall = (searchString) => ajax(ajaxOptions(searchString)).pipe((0, operators_1.mergeMap)(({ response }) => {
        const validation = ytj_1.iYtjListResponse.decode(response);
        const outcome = validation.fold((error) => Actions.searchFailure((0, errorHandling_1.parseValidationError)(error)), (companies) => Actions.searchSuccess(companies));
        return (0, rxjs_1.of)(outcome);
    }), (0, operators_1.catchError)((error) => {
        const responseError = (0, errorHandling_1.parseAjaxErrorResponse)(error);
        return (0, rxjs_1.of)(Actions.searchFailure(responseError));
    }));
    return action$.pipe((0, redux_observable_1.ofType)(ActionTypes.SEARCH_REQUEST), (0, operators_1.map)((action) => action), (0, operators_1.switchMap)(({ payload }) => ajaxCall(payload)));
};
exports.searchYtjCompany = searchYtjCompany;
//# sourceMappingURL=search.js.map